/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignCompanyRequest,
  AssignedCompanyRepresentation,
  DocumentRepresentation,
} from '../models/index';
import {
    AssignCompanyRequestFromJSON,
    AssignCompanyRequestToJSON,
    AssignedCompanyRepresentationFromJSON,
    AssignedCompanyRepresentationToJSON,
    DocumentRepresentationFromJSON,
    DocumentRepresentationToJSON,
} from '../models/index';

export interface AssignCompanyOperationRequest {
    docKey: string;
    assignCompanyRequest: AssignCompanyRequest;
}

export interface DeleteDocumentRequest {
    docKey: string;
}

export interface DeleteDocumentWarningRequest {
    docKey: string;
}

export interface DownloadDocumentRequest {
    docKey: string;
}

export interface DownloadDocumentsRequest {
    allDocuments?: Array<string>;
}

export interface GetAssignedCompanyKeysRequest {
    requestBody: Array<string>;
}

export interface GetDocumentRequest {
    docKey: string;
}

export interface GetDocumentsRequest {
    chunkSize?: number;
    chunkOffset?: number;
    text?: string;
    from?: number;
    until?: number;
    allGenerators?: Array<string>;
    anyGenerators?: Array<string>;
    allTags?: Array<string>;
    category?: string;
}

export interface RemoveCompanyRequest {
    docKey: string;
    companyKey: string;
}

export interface RetryRequest {
    docKey: string;
}

/**
 * 
 */
export class DocumentsApi extends runtime.BaseAPI {

    /**
     * Assign document to company
     * Assign document
     */
    async assignCompanyRaw(requestParameters: AssignCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['docKey'] == null) {
            throw new runtime.RequiredError(
                'docKey',
                'Required parameter "docKey" was null or undefined when calling assignCompany().'
            );
        }

        if (requestParameters['assignCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'assignCompanyRequest',
                'Required parameter "assignCompanyRequest" was null or undefined when calling assignCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/by-id/{docKey}/assigned-companies`;
        urlPath = urlPath.replace(`{${"docKey"}}`, encodeURIComponent(String(requestParameters['docKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignCompanyRequestToJSON(requestParameters['assignCompanyRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assign document to company
     * Assign document
     */
    async assignCompany(docKey: string, assignCompanyRequest: AssignCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.assignCompanyRaw({ docKey: docKey, assignCompanyRequest: assignCompanyRequest }, initOverrides);
    }

    /**
     * Delete a document, if owned by current user
     * Delete a document
     */
    async deleteDocumentRaw(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['docKey'] == null) {
            throw new runtime.RequiredError(
                'docKey',
                'Required parameter "docKey" was null or undefined when calling deleteDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/by-id/{docKey}`;
        urlPath = urlPath.replace(`{${"docKey"}}`, encodeURIComponent(String(requestParameters['docKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a document, if owned by current user
     * Delete a document
     */
    async deleteDocument(docKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentRaw({ docKey: docKey }, initOverrides);
    }

    /**
     * Delete a documents warning, if owned by current user
     * Delete a documents warning
     */
    async deleteDocumentWarningRaw(requestParameters: DeleteDocumentWarningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['docKey'] == null) {
            throw new runtime.RequiredError(
                'docKey',
                'Required parameter "docKey" was null or undefined when calling deleteDocumentWarning().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/by-id/{docKey}/warning`;
        urlPath = urlPath.replace(`{${"docKey"}}`, encodeURIComponent(String(requestParameters['docKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a documents warning, if owned by current user
     * Delete a documents warning
     */
    async deleteDocumentWarning(docKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentWarningRaw({ docKey: docKey }, initOverrides);
    }

    /**
     * Get a documents content if accessible by the current user
     * Download a document
     */
    async downloadDocumentRaw(requestParameters: DownloadDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['docKey'] == null) {
            throw new runtime.RequiredError(
                'docKey',
                'Required parameter "docKey" was null or undefined when calling downloadDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/download/{docKey}`;
        urlPath = urlPath.replace(`{${"docKey"}}`, encodeURIComponent(String(requestParameters['docKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get a documents content if accessible by the current user
     * Download a document
     */
    async downloadDocument(docKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadDocumentRaw({ docKey: docKey }, initOverrides);
        return await response.value();
    }

    /**
     * Download all accessible documents as zip
     * Get all documents
     */
    async downloadDocumentsRaw(requestParameters: DownloadDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['allDocuments'] != null) {
            queryParameters['all_documents'] = requestParameters['allDocuments']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download all accessible documents as zip
     * Get all documents
     */
    async downloadDocuments(allDocuments?: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadDocumentsRaw({ allDocuments: allDocuments }, initOverrides);
        return await response.value();
    }

    /**
     * Get assigned companies for the given document keys
     * Get assigned companies
     */
    async getAssignedCompanyKeysRaw(requestParameters: GetAssignedCompanyKeysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssignedCompanyRepresentation>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling getAssignedCompanyKeys().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/assigned-companies`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssignedCompanyRepresentationFromJSON(jsonValue));
    }

    /**
     * Get assigned companies for the given document keys
     * Get assigned companies
     */
    async getAssignedCompanyKeys(requestBody: Array<string>, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssignedCompanyRepresentation> {
        const response = await this.getAssignedCompanyKeysRaw({ requestBody: requestBody }, initOverrides);
        return await response.value();
    }

    /**
     * Get a documents accessible for the current user
     * Get a document
     */
    async getDocumentRaw(requestParameters: GetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentRepresentation>> {
        if (requestParameters['docKey'] == null) {
            throw new runtime.RequiredError(
                'docKey',
                'Required parameter "docKey" was null or undefined when calling getDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/by-id/{docKey}`;
        urlPath = urlPath.replace(`{${"docKey"}}`, encodeURIComponent(String(requestParameters['docKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentRepresentationFromJSON(jsonValue));
    }

    /**
     * Get a documents accessible for the current user
     * Get a document
     */
    async getDocument(docKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentRepresentation> {
        const response = await this.getDocumentRaw({ docKey: docKey }, initOverrides);
        return await response.value();
    }

    /**
     * Get a distinct list of all document categories
     * Get all document categories
     */
    async getDocumentCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/categories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a distinct list of all document categories
     * Get all document categories
     */
    async getDocumentCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getDocumentCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all documents accessible for the current user
     * Get all documents
     */
    async getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DocumentRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['chunkSize'] != null) {
            queryParameters['chunk_size'] = requestParameters['chunkSize'];
        }

        if (requestParameters['chunkOffset'] != null) {
            queryParameters['chunk_offset'] = requestParameters['chunkOffset'];
        }

        if (requestParameters['text'] != null) {
            queryParameters['text'] = requestParameters['text'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        if (requestParameters['until'] != null) {
            queryParameters['until'] = requestParameters['until'];
        }

        if (requestParameters['allGenerators'] != null) {
            queryParameters['all_generators'] = requestParameters['allGenerators']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['anyGenerators'] != null) {
            queryParameters['any_generators'] = requestParameters['anyGenerators']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['allTags'] != null) {
            queryParameters['all_tags'] = requestParameters['allTags']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DocumentRepresentationFromJSON));
    }

    /**
     * Get all documents accessible for the current user
     * Get all documents
     */
    async getDocuments(chunkSize?: number, chunkOffset?: number, text?: string, from?: number, until?: number, allGenerators?: Array<string>, anyGenerators?: Array<string>, allTags?: Array<string>, category?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DocumentRepresentation>> {
        const response = await this.getDocumentsRaw({ chunkSize: chunkSize, chunkOffset: chunkOffset, text: text, from: from, until: until, allGenerators: allGenerators, anyGenerators: anyGenerators, allTags: allTags, category: category }, initOverrides);
        return await response.value();
    }

    /**
     * Remove company assignment
     * Remove assignment
     */
    async removeCompanyRaw(requestParameters: RemoveCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['docKey'] == null) {
            throw new runtime.RequiredError(
                'docKey',
                'Required parameter "docKey" was null or undefined when calling removeCompany().'
            );
        }

        if (requestParameters['companyKey'] == null) {
            throw new runtime.RequiredError(
                'companyKey',
                'Required parameter "companyKey" was null or undefined when calling removeCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/by-id/{docKey}/assigned-companies/{companyKey}`;
        urlPath = urlPath.replace(`{${"docKey"}}`, encodeURIComponent(String(requestParameters['docKey'])));
        urlPath = urlPath.replace(`{${"companyKey"}}`, encodeURIComponent(String(requestParameters['companyKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove company assignment
     * Remove assignment
     */
    async removeCompany(docKey: string, companyKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCompanyRaw({ docKey: docKey, companyKey: companyKey }, initOverrides);
    }

    /**
     * Retry document creation or download (depending on document source)
     * Retry
     */
    async retryRaw(requestParameters: RetryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['docKey'] == null) {
            throw new runtime.RequiredError(
                'docKey',
                'Required parameter "docKey" was null or undefined when calling retry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/documents/by-id/{docKey}/retry`;
        urlPath = urlPath.replace(`{${"docKey"}}`, encodeURIComponent(String(requestParameters['docKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retry document creation or download (depending on document source)
     * Retry
     */
    async retry(docKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retryRaw({ docKey: docKey }, initOverrides);
    }

}
